import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ClickAwayListener, TooltipProps, Typography } from '@mui/material';

import { StyledPlaceholderTooltip } from './styled';

type PropsType = Omit<TooltipProps, 'title'> & {
	children: ReactNode;
	title?: string;
};

function PlaceholderToolTip({ children, ...props }: PropsType) {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const isControlled = typeof props.open !== 'undefined';
	const open = isControlled ? props.open : isOpen;

	const handleOpen = (event: React.SyntheticEvent | Event) => {
		if (isControlled) {
			props.onOpen?.(event as React.SyntheticEvent);
		} else {
			setIsOpen(true);
		}
	};

	const handleClose = (event: React.SyntheticEvent | Event) => {
		if (isControlled) {
			props.onClose?.(event as React.SyntheticEvent);
		} else {
			setIsOpen(false);
		}
	};

	const handleToggle = (event: React.SyntheticEvent) => {
		if (open) {
			handleClose(event);
		} else {
			handleOpen(event);
		}
	};

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<Box>
				<StyledPlaceholderTooltip
					{...props}
					title={<Typography variant="body2">{props.title || t('shared.comingSoon')}</Typography>}
					arrow
					open={open}
					onClose={handleClose}
					onOpen={handleOpen}
					disableHoverListener
					disableFocusListener
					disableTouchListener
				>
					<Box
						role="button"
						tabIndex={0}
						sx={{ cursor: 'pointer' }}
						onClick={handleToggle}
						onKeyDown={(event) => {
							if (event.key === 'Enter' || event.key === ' ') {
								event.preventDefault();
								handleToggle(event);
							}
						}}
					>
						{children}
					</Box>
				</StyledPlaceholderTooltip>
			</Box>
		</ClickAwayListener>
	);
}

export default PlaceholderToolTip;
